import { render } from "./PagamentoRecargaSucesso.vue?vue&type=template&id=0b8e6d5a"
import script from "./PagamentoRecargaSucesso.vue?vue&type=script&lang=js"
export * from "./PagamentoRecargaSucesso.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__